import { makeStyles } from "@material-ui/core/styles";

/**
 * Styling for the presentational Receipt components (ReceiptPanel,
 * ReceiptBody, ReceiptHeaderFooter). Modeled on the paper-receipt layout of
 * ValetReceiptDetails.styles.js and the shared MobilePayment styles, using
 * MUI v4 makeStyles.
 */
export const useStyles = makeStyles((theme) => ({
  summaryContent: {
    display: "flex",
    flexDirection: "column",
  },
  summaryTitle: {
    fontWeight: "bold",
  },
  summaryDateTime: {
    color: theme.palette.text?.secondary,
    fontSize: "0.9rem",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  panel: {
    // Separate consecutive receipt panels (Receipt 1, Receipt 2, ...) so they
    // are not flush against each other, matching the mockup spacing.
    marginBottom: theme.spacing(1.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  receiptContainer: {
    padding: theme.spacing(2),
    width: "fit-content",
    maxWidth: 400,
    margin: "0 auto",
  },
  container: {
    width: "100%",
    maxWidth: 400,
  },
  headerFooter: {
    width: "100%",
    textAlign: "center",
  },
  label: {
    textAlign: "left",
    fontFamily: "Roboto",
    fontSize: "1rem",
  },
  value: {
    textAlign: "right",
    fontSize: "1rem",
    wordBreak: "break-all",
  },
  cardType: {
    textAlign: "center",
    fontSize: "1rem",
  },
  sectionTitle: {
    width: "100%",
    textAlign: "center",
  },
  totalLabel: {
    textAlign: "left",
    fontSize: "1rem",
    fontWeight: "bold",
  },
  totalValue: {
    textAlign: "right",
    fontSize: "1rem",
    fontWeight: "bold",
  },
  divider: {
    width: "100%",
    margin: "15px 0",
    height: "2px",
  },
  placeholder: {
    fontStyle: "italic",
    color: theme.palette.text?.secondary,
  },
}));

/**
 * Styling for the redesigned Send Receipt form (SendReceiptForm). A single
 * card containing an email field and a phone field, each with its own submit
 * affordance. Modeled on the shared MobilePayment form styles (flex column,
 * spacing) using MUI v4 makeStyles.
 */
export const useSendReceiptStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    maxWidth: 400,
    margin: "0 auto",
    gap: theme.spacing(1),
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1, 0),
  },
  input: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
  },
  divider: {
    width: "100%",
    margin: theme.spacing(2, 0),
  },
}));
